// MAISON NOIR - v7 (Product Page Eme Studios)
(function() {
  'use strict';

  // === WISHLIST (localStorage) ===
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('mn_wishlist') || '[]'); }
    catch(e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem('mn_wishlist', JSON.stringify(list));
    updateAllBookmarks();
    updateHeaderDot();
  }

  function addToWishlist(handle) {
    var list = getWishlist();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      saveWishlist(list);
      return true;
    }
    return false;
  }

  function removeFromWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
      saveWishlist(list);
    }
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) > -1;
  }

  function updateAllBookmarks() {
    var list = getWishlist();
    document.querySelectorAll('.mn-bookmark[data-handle]').forEach(function(btn) {
      var svg = btn.querySelector('svg');
      if (!svg) return;
      svg.setAttribute('fill', list.indexOf(btn.dataset.handle) > -1 ? 'currentColor' : 'none');
    });
    // Also update PDP bookmark
    document.querySelectorAll('.mn-pdp-bookmark[data-handle]').forEach(function(btn) {
      var svg = btn.querySelector('svg');
      if (!svg) return;
      svg.setAttribute('fill', list.indexOf(btn.dataset.handle) > -1 ? 'currentColor' : 'none');
    });
  }

  function updateHeaderDot() {
    var dot = document.querySelector('.mn-wishlist-dot');
    if (dot) {
      dot.style.display = getWishlist().length > 0 ? 'block' : 'none';
    }
  }

  // === WISHLIST DRAWER ===
  var wlDrawer = null;
  var wlOverlay = null;

  function createWishlistDrawer() {
    if (wlDrawer) return;

    wlOverlay = document.createElement('div');
    wlOverlay.className = 'mn-wl-overlay';
    wlOverlay.addEventListener('click', closeWishlistDrawer);
    document.body.appendChild(wlOverlay);

    wlDrawer = document.createElement('div');
    wlDrawer.className = 'mn-wl-drawer';
    wlDrawer.innerHTML = '<div class="mn-wl-header"><span class="mn-wl-title">LISTA DE DESEOS</span><button class="mn-wl-close">\u2715</button></div><div class="mn-wl-content"></div>';
    wlDrawer.querySelector('.mn-wl-close').addEventListener('click', closeWishlistDrawer);
    document.body.appendChild(wlDrawer);
  }

  function openWishlistDrawer() {
    createWishlistDrawer();
    renderWishlistList();
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        wlDrawer.classList.add('active');
        wlOverlay.classList.add('active');
        document.body.classList.add('overflow-hidden');
      });
    });
  }

  function closeWishlistDrawer() {
    if (!wlDrawer) return;
    wlDrawer.classList.remove('active');
    wlOverlay.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  function renderWishlistList() {
    if (!wlDrawer) return;
    var content = wlDrawer.querySelector('.mn-wl-content');
    var items = getWishlist();

    if (items.length === 0) {
      content.innerHTML = '<div class="mn-wl-empty">No tienes productos guardados</div>';
      return;
    }

    content.innerHTML = '<div class="mn-wl-section-title">ART\u00cdCULOS</div><div class="mn-wl-items"></div>';
    var itemsEl = content.querySelector('.mn-wl-items');

    items.forEach(function(handle) {
      fetch('/products/' + handle + '.json')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var p = data.product;
          var img = p.images.length > 0 ? p.images[0].src : '';
          var price = p.variants[0].price;
          var compare = p.variants[0].compare_at_price;

          var item = document.createElement('div');
          item.className = 'mn-wl-item';
          item.innerHTML = '<img class="mn-wl-item-img" src="' + img + '" alt="' + p.title + '">' +
            '<div class="mn-wl-item-info">' +
            '<div class="mn-wl-item-name">' + p.title.toUpperCase() + '</div>' +
            '<div class="mn-wl-item-price">' + (compare ? '<s>' + compare + ' \u20ac</s> ' : '') + price + ' \u20ac</div>' +
            '<button class="mn-wl-item-add">A\u00d1ADIR AL CARRITO</button>' +
            '</div>' +
            '<button class="mn-wl-item-remove">ELIMINAR</button>';

          item.querySelector('.mn-wl-item-add').addEventListener('click', function() {
            showTallaSelector(handle);
          });

          item.querySelector('.mn-wl-item-remove').addEventListener('click', function() {
            removeFromWishlist(handle);
            item.remove();
            if (getWishlist().length === 0) {
              content.innerHTML = '<div class="mn-wl-empty">No tienes productos guardados</div>';
            }
          });

          itemsEl.appendChild(item);
        })
        .catch(function() {});
    });
  }

  function showTallaSelector(handle) {
    if (!wlDrawer) return;
    var content = wlDrawer.querySelector('.mn-wl-content');
    content.innerHTML = '<div class="mn-wl-loading">Cargando...</div>';

    fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var p = data.product;
        var img = p.images.length > 0 ? p.images[0].src : '';
        var price = p.variants[0].price;

        content.innerHTML = '<div class="mn-wl-talla-header">SELECCIONAR TALLA</div>' +
          '<div class="mn-wl-talla-product">' +
          '<img class="mn-wl-talla-img" src="' + img + '" alt="' + p.title + '">' +
          '<div class="mn-wl-talla-info">' +
          '<div class="mn-wl-talla-name">' + p.title.toUpperCase() + '</div>' +
          '<div class="mn-wl-talla-price">' + price + ' \u20ac</div>' +
          '</div></div>' +
          '<div class="mn-wl-talla-buttons"></div>';

        var btnsEl = content.querySelector('.mn-wl-talla-buttons');
        p.variants.forEach(function(v) {
          var btn = document.createElement('button');
          btn.className = 'mn-wl-talla-btn';
          btn.textContent = v.title;
          btn.addEventListener('click', function() {
            btn.textContent = '...';
            var formData = new FormData();
            formData.append('id', v.id);
            formData.append('quantity', '1');
            formData.append('sections', 'cart-drawer,cart-icon-bubble');
            formData.append('sections_url', window.location.pathname);
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
              body: formData
            })
            .then(function(r) { return r.json(); })
            .then(function(response) {
              if (response.status) return;
              closeWishlistDrawer();
              var cart = document.querySelector('cart-drawer');
              if (cart && typeof cart.renderContents === 'function') {
                cart.classList.remove('is-empty');
                cart.renderContents(response);
              }
            });
          });
          btnsEl.appendChild(btn);
        });
      });
  }

  // === BUILD SIZE OVERLAY HTML from variants ===
  function buildSizeOverlay(variants) {
    var html = '<div class="mn-sizes">';
    variants.forEach(function(v) {
      var sold = !v.available;
      html += '<button class="mn-sizes-btn' + (sold ? ' mn-sizes-btn--out' : '') + '" ' +
        'data-variant-id="' + v.id + '" data-size="' + v.title + '" ' +
        (sold ? '' : 'onclick="window.mnAddToCart(' + v.id + ', this)"') +
        '>' + v.title + '</button>';
    });
    html += '</div>';
    return html;
  }

  // === ADD TO CART (for size overlay on product cards) ===
  function addToCart(variantId, btn) {
    var orig = btn.dataset.size;
    btn.textContent = '...';
    btn.style.pointerEvents = 'none';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(function(r) { return r.json(); })
    .then(function(response) {
      if (response.status) {
        btn.textContent = '\u2717';
        btn.style.pointerEvents = '';
        setTimeout(function() { btn.textContent = orig; }, 2000);
        return;
      }
      btn.textContent = '\u2713';
      btn.style.pointerEvents = '';
      setTimeout(function() { btn.textContent = orig; }, 2000);
      var cart = document.querySelector('cart-drawer');
      if (cart && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty');
        cart.renderContents(response);
      }
    })
    .catch(function() {
      btn.textContent = '\u2717';
      btn.style.pointerEvents = '';
      setTimeout(function() { btn.textContent = orig; }, 2000);
    });
  }

  window.mnAddToCart = addToCart;

  // === INIT CARDS ===
  function initCards() {
    document.querySelectorAll('.card-wrapper').forEach(function(card) {
      if (card.dataset.mnInit) return;
      card.dataset.mnInit = '1';

      // Make image clickable
      var media = card.querySelector('.card__media');
      var productLink = card.querySelector('.card__heading a');
      if (media && productLink) {
        media.style.cursor = 'pointer';
        media.addEventListener('click', function(e) {
          if (e.target.closest('.mn-sizes') || e.target.closest('.mn-bookmark')) return;
          window.location.href = productLink.getAttribute('href');
        });
      }

      // OVERRIDE bookmark onclick from JS
      var bm = card.querySelector('.mn-bookmark[data-handle]');
      if (bm) {
        bm.removeAttribute('onclick');
        bm.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var handle = this.dataset.handle;
          if (isInWishlist(handle)) {
            removeFromWishlist(handle);
          } else {
            addToWishlist(handle);
            openWishlistDrawer();
          }
        }, true);
      }
    });
  }

  // === PRODUCT PAGE ENHANCEMENTS ===
  function initProductPage() {
    if (!document.querySelector('product-info')) return;

    var infoContainer = document.querySelector('.product__info-container');
    if (!infoContainer) return;

    // Make breadcrumb clickable
    var breadcrumb = infoContainer;
    breadcrumb.addEventListener('click', function(e) {
      var rect = breadcrumb.getBoundingClientRect();
      if (e.target === breadcrumb && e.clientY < rect.top + 30) {
        window.history.back();
      }
    });

    // Inject "RECOMENDADO" section below images on desktop
    if (window.innerWidth >= 990) {
      injectRecommendedSection();
    }

    // Inject thumbnail strip (desktop: vertical sticky; mobile: horizontal scroll via CSS)
    injectThumbnailStrip();

    // Wrap PayPal button for border-radius
    var paypalBtn = document.querySelector('product-info .shopify-payment-button');
    if (paypalBtn && !paypalBtn.classList.contains('mn-paypal-wrapped')) {
      paypalBtn.classList.add('mn-paypal-wrapped');
      paypalBtn.style.borderRadius = '6px';
      paypalBtn.style.overflow = 'hidden';
    }

    // Inject bookmark on product page (next to title)
    var titleEl = infoContainer.querySelector('.product__title');
    if (titleEl && !infoContainer.querySelector('.mn-pdp-bookmark')) {
      var handle = window.location.pathname.split('/').pop();
      if (handle) {
        titleEl.style.position = 'relative';
        titleEl.style.paddingRight = '36px';
        var bm = document.createElement('button');
        bm.className = 'mn-pdp-bookmark';
        bm.dataset.handle = handle;
        bm.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>';
        bm.addEventListener('click', function(e) {
          e.preventDefault();
          if (isInWishlist(handle)) {
            removeFromWishlist(handle);
          } else {
            addToWishlist(handle);
          }
        });
        titleEl.appendChild(bm);
      }
    }

    // Inject model info after price block
    var priceBlock = infoContainer.querySelector('[id^="price-"]');
    if (priceBlock && !infoContainer.querySelector('.mn-model-info')) {
      var modelInfo = document.createElement('div');
      modelInfo.className = 'mn-model-info';
      modelInfo.innerHTML = 'Modelo (hombre) 188 cm de altura y talla L.<br>Modelo (mujer) 170 cm de altura y talla S.';
      priceBlock.insertAdjacentElement('afterend', modelInfo);
    }

    // Move related products inside the info panel on desktop
    moveRelatedProducts();
  }

  // Inject "Completa tu look" into info panel using Shopify recommendations API
  function moveRelatedProducts() {
    if (window.innerWidth < 990) return;
    var infoWrapper = document.querySelector('.product--stacked .product__info-wrapper');
    if (!infoWrapper || infoWrapper.querySelector('.mn-completa-look')) return;

    var productInfo = document.querySelector('product-info');
    var productId = productInfo ? productInfo.dataset.productId : null;
    if (!productId) return;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || data.products.length === 0) return;

        var container = document.createElement('div');
        container.className = 'mn-completa-look';

        var h = document.createElement('h3');
        h.textContent = 'COMPLETA TU LOOK';
        container.appendChild(h);

        var grid = document.createElement('div');
        grid.className = 'mn-look-grid';

        data.products.forEach(function(p, i) {
          if (i >= 4) return;
          var img = '';
          if (p.featured_image) img = p.featured_image;
          else if (p.images && p.images.length > 0) img = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
          if (img && img.startsWith('//')) img = 'https:' + img;
          var rawPrice = p.variants && p.variants.length > 0 ? p.variants[0].price : '0';
          var formatted = (parseFloat(rawPrice) / 100).toFixed(2).replace('.', ',') + ' \u20ac';

          var sizesHtml = p.variants ? buildSizeOverlay(p.variants) : '';

          var item = document.createElement('div');
          item.className = 'mn-look-item';
          item.innerHTML = '<div class="mn-look-img-wrap" style="position:relative;cursor:pointer;">' +
            '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' +
            sizesHtml +
            '</div>' +
            '<div class="mn-look-name"><a href="/products/' + p.handle + '">' + p.title + '</a>' +
            '<button class="mn-look-bookmark mn-bookmark" data-handle="' + p.handle + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg></button></div>' +
            '<div class="mn-look-price">' + formatted + '</div>';

          // Click image goes to product (unless clicking size btn)
          item.querySelector('.mn-look-img-wrap').addEventListener('click', function(e) {
            if (e.target.closest('.mn-sizes-btn')) return;
            window.location.href = '/products/' + p.handle;
          });

          item.querySelector('.mn-look-bookmark').addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var handle = this.dataset.handle;
            if (isInWishlist(handle)) { removeFromWishlist(handle); }
            else { addToWishlist(handle); }
          });

          grid.appendChild(item);
        });

        container.appendChild(grid);
        infoWrapper.appendChild(container);
        updateAllBookmarks();
      })
      .catch(function() {});
  }

  // === THUMBNAIL STRIP (left column) ===
  function injectThumbnailStrip() {
    var productGrid = document.querySelector('.product--stacked');
    if (!productGrid || productGrid.querySelector('.mn-thumb-strip')) return;

    var mediaItems = productGrid.querySelectorAll('.product__media-item');
    if (mediaItems.length < 1) return;

    var strip = document.createElement('div');
    strip.className = 'mn-thumb-strip';

    mediaItems.forEach(function(item, i) {
      var img = item.querySelector('img');
      if (!img) return;

      var thumb = document.createElement('div');
      thumb.className = 'mn-thumb' + (i === 0 ? ' active' : '');
      thumb.innerHTML = '<img src="' + img.src + '" alt="" loading="lazy">';
      thumb.addEventListener('click', function() {
        item.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      strip.appendChild(thumb);
    });

    // Insert as first child of product grid
    productGrid.insertBefore(strip, productGrid.firstChild);

    // Sync active thumb on scroll using IntersectionObserver
    var thumbs = strip.querySelectorAll('.mn-thumb');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var idx = Array.prototype.indexOf.call(mediaItems, entry.target);
          thumbs.forEach(function(t, j) {
            t.classList.toggle('active', j === idx);
          });
          // Scroll thumb into view if needed
          if (thumbs[idx]) {
            thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      });
    }, { threshold: 0.5 });

    mediaItems.forEach(function(item) {
      observer.observe(item);
    });
  }

  // === RECOMMENDED SECTION (below images) ===
  function injectRecommendedSection() {
    // Inject AFTER the product grid (spans full width)
    var productGrid = document.querySelector('.product--stacked');
    if (!productGrid || document.querySelector('.mn-recommended')) return;

    var productInfo = document.querySelector('product-info');
    var productId = productInfo ? productInfo.dataset.productId : null;
    if (!productId) return;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || data.products.length === 0) return;

        var section = document.createElement('div');
        section.className = 'mn-recommended';

        var h = document.createElement('h3');
        h.textContent = 'RECOMENDADO';
        section.appendChild(h);

        var grid = document.createElement('div');
        grid.className = 'mn-rec-grid';

        data.products.forEach(function(p) {
          var img = '';
          if (p.featured_image) img = p.featured_image;
          else if (p.images && p.images.length > 0) img = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
          if (img && img.startsWith('//')) img = 'https:' + img;
          var rawPrice = p.variants && p.variants.length > 0 ? p.variants[0].price : '0';
          var formatted = (parseFloat(rawPrice) / 100).toFixed(2).replace('.', ',') + ' \u20ac';

          var sizesHtml = p.variants ? buildSizeOverlay(p.variants) : '';

          var item = document.createElement('div');
          item.className = 'mn-rec-item';
          item.innerHTML = '<div class="mn-rec-img-wrap">' +
            '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' +
            sizesHtml +
            '</div>' +
            '<div class="mn-rec-info"><a href="/products/' + p.handle + '" class="mn-rec-name">' + p.title + '</a>' +
            '<button class="mn-rec-bookmark mn-bookmark" data-handle="' + p.handle + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg></button></div>' +
            '<div class="mn-rec-price">' + formatted + '</div>';

          // Click image goes to product (unless clicking size btn)
          item.querySelector('.mn-rec-img-wrap').addEventListener('click', function(e) {
            if (e.target.closest('.mn-sizes-btn')) return;
            window.location.href = '/products/' + p.handle;
          });

          grid.appendChild(item);
        });

        section.appendChild(grid);
        // Insert after the product grid, inside page-width
        productGrid.parentElement.insertBefore(section, productGrid.nextSibling);
        initCards();
        updateAllBookmarks();
      })
      .catch(function() {});
  }

  // === MEGA MENU (Catálogo hover) ===
  function initMegaMenu() {
    var catalogLink = document.querySelector('#HeaderMenu-colecciones') || document.querySelector('#HeaderMenu-catalogo');
    if (!catalogLink || document.querySelector('.mn-mega-menu')) return;

    // Fetch collections
    fetch('/collections.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var cols = data.collections || [];
        if (cols.length === 0) return;

        var menu = document.createElement('div');
        menu.className = 'mn-mega-menu';

        var grid = document.createElement('div');
        grid.className = 'mn-mega-menu-grid';

        cols.forEach(function(c) {
          if (c.handle === 'frontpage') return;
          var img = c.image ? (c.image.src || c.image) : '';
          if (!img && c.products && c.products.length > 0) {
            var p = c.products[0];
            img = p.featured_image || (p.images && p.images.length > 0 ? p.images[0] : '');
          }
          if (typeof img === 'string' && img.startsWith('//')) img = 'https:' + img;

          var col = document.createElement('a');
          col.className = 'mn-mega-col';
          col.href = '/collections/' + c.handle;
          col.innerHTML = (img ? '<img src="' + img + '" alt="' + c.title + '" loading="lazy">' : '<div style="width:100%;aspect-ratio:3/4;background:#f1f1f1;border-radius:6px;"></div>') +
            '<div class="mn-mega-col-info"><div class="mn-mega-col-name">' + c.title + '</div><div class="mn-mega-col-season">SS26</div></div>';

          grid.appendChild(col);
        });

        menu.appendChild(grid);
        document.body.appendChild(menu);

        // Position: attach to bottom of header (no gap)
        var headerH = document.querySelector('.header-wrapper');
        function positionMenu() {
          if (headerH) {
            var rect = headerH.getBoundingClientRect();
            // Overlap 1px to eliminate the gap
            menu.style.top = (rect.bottom - 1) + 'px';
          }
        }

        // Show/hide on hover
        var hideTimeout;
        function showMega() {
          clearTimeout(hideTimeout);
          positionMenu();
          menu.classList.add('active');
          if (headerH) headerH.classList.add('mn-mega-open');
        }
        function hideMega() {
          hideTimeout = setTimeout(function() {
            menu.classList.remove('active');
            if (headerH) headerH.classList.remove('mn-mega-open');
          }, 200);
        }
        catalogLink.parentElement.addEventListener('mouseenter', showMega);
        catalogLink.parentElement.addEventListener('mouseleave', hideMega);
        menu.addEventListener('mouseenter', function() { clearTimeout(hideTimeout); });
        menu.addEventListener('mouseleave', hideMega);
      })
      .catch(function() {});
  }

  // === FLOATING HEADER ===
  function initHeader() {
    var hw = document.querySelector('.header-wrapper');
    if (!hw) return;
    var hero = document.querySelector('.shopify-section-image-banner, [class*="banner"], [class*="hero"]');
    var threshold = hero ? hero.offsetHeight - 80 : 300;
    window.addEventListener('scroll', function() {
      hw.classList.toggle('scrolled-past-hero', window.scrollY > threshold);
    }, { passive: true });

    // Wishlist dot indicator
    var wishlistIcon = document.querySelector('.header__icon--wishlist');
    if (wishlistIcon) {
      wishlistIcon.style.position = 'relative';
      if (!wishlistIcon.querySelector('.mn-wishlist-dot')) {
        var dot = document.createElement('span');
        dot.className = 'mn-wishlist-dot';
        wishlistIcon.appendChild(dot);
      }
      // Open wishlist drawer on click
      wishlistIcon.addEventListener('click', function(e) {
        e.preventDefault();
        openWishlistDrawer();
      });
    }
  }

  // === BOOT ===
  function boot() {
    initHeader();
    initMegaMenu();
    initCards();
    initProductPage();
    updateAllBookmarks();
    updateHeaderDot();
    new MutationObserver(function() {
      initCards();
      updateAllBookmarks();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

